var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAssignment = function SvgAssignment(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 27",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.375 18.5H11H5.75M18.25 14.5C13.3684 14.5 5.75 14.5 5.75 14.5M18.25 10.5H12H5.75M20.75 3.75H15.525C15 2.3 13.625 1.25 12 1.25C10.375 1.25 9 2.3 8.475 3.75H3.25C1.875 3.75 0.75 4.875 0.75 6.25V23.75C0.75 25.125 1.875 26.25 3.25 26.25H20.75C22.125 26.25 23.25 25.125 23.25 23.75V6.25C23.25 4.875 22.125 3.75 20.75 3.75ZM12 3.75C12.6875 3.75 13.25 4.3125 13.25 5C13.25 5.6875 12.6875 6.25 12 6.25C11.3125 6.25 10.75 5.6875 10.75 5C10.75 4.3125 11.3125 3.75 12 3.75Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAssignment, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Assignment.088214df.svg";
export { ForwardRef as ReactComponent };